import { z } from "zod";
import {
  AMOUNT,
  BANK_CONF,
  BANK_INFO,
  BILLING_MONTH_YEAR,
  CASH_APP_FILE,
  CASH_APP_ID,
  CHEQUE_NO,
  CLEARING,
  COMBINE,
  COMMENT,
  CURRENCY,
  CUSTOMER_ACC,
  DATE,
  DOCUMENT_ID,
  DRCR,
  GL_ACCOUNT,
  LINE_ITEM_TEXT,
  LINE_ITEMS,
  OFFSET_ACC,
  OL_DATE,
  OL_DOC_LI,
  OL_REF,
  OL_TOTAL,
  PAYMENT_METHOD,
  POSTING_DATE,
  POSTING_MONTH,
  SUB_LEDGER,
  YEAR,
} from "./consts";

export const schema = z.object({
  [DOCUMENT_ID]: z.string().min(1, "This field is required"),
  [CASH_APP_ID]: z.string().optional(),
  [BILLING_MONTH_YEAR]: z.any(),
  [COMMENT]: z.string().min(1, "This field is required"),
  // [ATTACHMENT_FILE]: z.any(),
  [CASH_APP_FILE]: z.any(),
  [POSTING_DATE]: z.any(),
  [POSTING_MONTH]: z.string().optional(),
  [YEAR]: z.string().optional(),
  [LINE_ITEMS]: z
    .object({
      [DATE]: z.any().optional(),
      [CURRENCY]: z.string().optional(),
      [BANK_INFO]: z.string().optional(),
      [BANK_CONF]: z.string().optional(),
      [DRCR]: z.string().optional(),
      [LINE_ITEM_TEXT]: z.string().optional(),
      [CHEQUE_NO]: z.string().optional(),
      [AMOUNT]: z.string().optional(),
      [GL_ACCOUNT]: z.string().optional(),
      [SUB_LEDGER]: z.boolean().optional(),
      [COMBINE]: z.boolean().optional(),
      [CUSTOMER_ACC]: z.string().optional(),
      [PAYMENT_METHOD]: z.string().optional(),
      [OFFSET_ACC]: z.string().optional(),
      [CLEARING]: z.boolean().optional(),
      [OL_DATE]: z.any().optional(),
      [OL_REF]: z.string().optional(),
      [OL_DOC_LI]: z.string().optional(),
      [OL_TOTAL]: z.string().optional(),
    })
    .array(),
});

export type formValues = z.infer<typeof schema>;
